import { render, staticRenderFns } from "./DialogPedidosVencidos.vue?vue&type=template&id=d649532a"
import script from "./DialogPedidosVencidos.vue?vue&type=script&lang=js"
export * from "./DialogPedidosVencidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports